import { useContext, useState } from "react";

import Fade from '~/components/Fade';
import StyledButton from '~/components/StyledButton';
import { AppContext } from '~/contexts/AppContext';
import { MenuScreen } from '~/App';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faLanguage } from "@fortawesome/free-solid-svg-icons/faLanguage";
import { faBuilding } from "@fortawesome/free-solid-svg-icons/faBuilding";
import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { faPalette } from "@fortawesome/free-solid-svg-icons/faPalette";

import StyledContentPanel from '~/components/StyledContentPanel';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { useTranslation } from "react-i18next";
import MatomoTracker from '~/util/matomo/MatomoTracker';

const MainMenu: React.FC = () => {
    const { t } = useTranslation();

    const { setMenuScreen } = useContext(AppContext)!;

    const getInitialVariant = (): 'new' | 'old' => {
        const savedVariant = localStorage.getItem('languageSelectorVariant');
        return (savedVariant as 'new' | 'old') || 'old';
    };

    const [languageSelectorVariant, setLanguageSelectorVariant] = useState<'new' | 'old'>(getInitialVariant());

    const backClicked = () => {

        MatomoTracker.trackEvent({
            category: 'options-menu', 
            action: 'click-back-button',
        });

        setMenuScreen(MenuScreen.None);
    };

    const profileClicked = () => {

        MatomoTracker.trackEvent({
            category: 'options-menu', 
            action: 'click-profile-button',
        });

        setMenuScreen(MenuScreen.Profile);
    };

    const aboutUsClicked = () => {

        const url = 'https://www.cnts.bg/';

        MatomoTracker.trackLink({ href: url});

        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const languageClicked = () => {

        MatomoTracker.trackEvent({
            category: 'options-menu', 
            action: 'click-language-button',
        });

        setMenuScreen(MenuScreen.Language);
    };

    const privacyNoticeClicked = () => {

        MatomoTracker.trackEvent({
            category: 'options-menu', 
            action: 'click-privacy-notice-button',
        });

        setMenuScreen(MenuScreen.PrivacyNoticeMenu);
    };

    const toggleLanguageSelectorVariant = () => {
        const newVariant = languageSelectorVariant === 'new' ? 'old' : 'new';
        setLanguageSelectorVariant(newVariant);
        localStorage.setItem('languageSelectorVariant', newVariant);

        window.location.reload();
    };

    return (
        <div style={{ padding: '20px' }}>
            <Fade cascade>
                <StyledContentPanel style={{ marginBottom: '20px' }}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faGear} /></span>
                    {t('menu_main_title')}
                </StyledContentPanel>
                <StyledButton onClick={backClicked}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faArrowLeft} /></span>
                    {t('button_back')}
                </StyledButton>
                <StyledButton onClick={profileClicked}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faUser} /></span>
                    {t('menu_main_profile')}
                </StyledButton>
                <StyledButton onClick={aboutUsClicked}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faBuilding} /></span>
                    {t('menu_main_about_us')}
                </StyledButton>
                <StyledButton onClick={languageClicked}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faLanguage} /></span>
                    {t('menu_main_language')}
                </StyledButton>
                <StyledButton onClick={privacyNoticeClicked}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faLock} /></span>
                    {t('menu_main_privacy_notice')}
                </StyledButton>
                <StyledButton onClick={toggleLanguageSelectorVariant}>
                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faPalette} /></span>
                    {languageSelectorVariant === 'new' ? t('menu_main_old_design_variant') : t('menu_main_new_design_variant')}
                </StyledButton>
            </Fade>
        </div>
    );
};

export default MainMenu;